{
  "name": "conductor-web",
  "version": "1.3.1",
  "description": "___",
  "homepage": "https://gitlab.com/neuroanimation/conductor-web#readme",
  "bugs": {
    "url": "https://gitlab.com/neuroanimation/conductor-web/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+ssh://git@gitlab.com/neuroanimation/conductor-web.git"
  },
  "license": "ISC",
  "author": "",
  "type": "commonjs",
  "scripts": {
    "dev": "cross-env NODE_ENV=development npx concurrently \"npx wait-on npx rimraf .parcel-cache dist\" \"parcel src/index.html\"",
    "build": "parcel build src/index.html",
    "build-ci": "parcel build src/index.html --dist-dir public --public-url /"
  },
  "devDependencies": {
    "@parcel/packager-raw-url": "^2.16.4",
    "@parcel/transformer-sass": "^2.16.4",
    "@parcel/transformer-webmanifest": "^2.16.4",
    "@types/node": "^25.9.3",
    "@types/react": "^19.2.14",
    "@types/react-dom": "^19.2.3",
    "concurrently": "^9.2.1",
    "cross-env": "^10.1.0",
    "parcel": "^2.16.4",
    "parcel-reporter-static-files-copy": "^1.5.3",
    "process": "^0.11.10",
    "timers-browserify": "^2.0.12"
  },
  "dependencies": {
    "@daypicker/react": "^10.0.1",
    "@react-oauth/google": "^0.13.5",
    "chart.js": "^4.5.1",
    "motion": "^12.43.0",
    "react": "^19.2.6",
    "react-chartjs-2": "^5.3.1",
    "react-dom": "^19.2.6",
    "react-icons": "^5.6.0",
    "react-router": "^7.15.0",
    "react-router-dom": "^7.15.0",
    "react-select": "^5.10.2",
    "ua-parser-js": "^2.0.10",
    "uuid": "^14.0.1"
  },
  "staticFiles": [
    {
      "staticPath": "./src/static",
      "staticOutPath": "static"
    },
    {
      "staticPath": "./src/static/favicons"
    },
    {
      "staticPath": "_redirects"
    }
  ],
  "@parcel/resolver-default": {
    "packageExports": true
  }
}
